import { components } from "@certn/legacy-api/generated-schemas/people";

import { ValidationRuleType } from "./types";

export function requireUSAddressRule(): ValidationRuleType {
  return {
    isValid: (
      addresses: components["schemas"]["AddressesCheckField"]["value"]
    ) => addresses.some(({ country }) => country === "US"),
  };
}
